import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import { connect } from 'react-redux';

import Modal from '../../../common/modal/Modal';
import MaintenanceChecklistAdditionalActivityForm from './MaintenanceChecklistAdditionalActivityForm';

import {
  getMaintenanceChecklist,
  postMaintenanceChecklistAdditionalActivities,
} from '../../../../actions';

const getId = (value) => {
  if (value === null || value === undefined || value === '') {
    return null;
  }

  if (
    typeof value === 'number' ||
    typeof value === 'string' ||
    typeof value === 'boolean'
  ) {
    return value;
  }

  return value.value || value.id || null;
};

const buildAdditionalActivity = (formValues) => {
  const maintenanceFailMode = formValues.maintenanceFailModeId;

  return {
    maintenanceFailModeId: getId(maintenanceFailMode),

    maintenanceFailModeCategoryId: getId(
      formValues.maintenanceFailModeCategoryId,
    ),

    activityId:
      maintenanceFailMode && maintenanceFailMode.activityId
        ? getId(maintenanceFailMode.activityId)
        : getId(formValues.activityId),

    comment: formValues.comments || formValues.comment || '',

    recurrence: getId(formValues.recurrence),

    maintenanceWarningType: getId(formValues.maintenanceWarningType),
  };
};

const MaintenanceChecklistAdditionalActivityButton = ({
  maintenanceChecklist,
  dispatchPostMaintenanceChecklistAdditionalActivities,
  dispatchGetMaintenanceChecklist,
  disabled,
}) => {
  const [showModal, setShowModal] = useState(false);

  const openModal = () => {
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
  };

  const onSubmit = async (formValues) => {
    const additionalActivity = buildAdditionalActivity(formValues);

    const response = await dispatchPostMaintenanceChecklistAdditionalActivities(
      {
        maintenanceChecklistId: maintenanceChecklist.id,

        maintenanceChecklistAdditionalActivityExecutionList: [
          additionalActivity,
        ],
      },
    );

    if (!response) {
      return;
    }

    await dispatchGetMaintenanceChecklist({
      maintenanceChecklistId: maintenanceChecklist.id,
    });

    closeModal();
  };

  return (
    <>
      <Modal
        show={showModal}
        title="Agregar actividad adicional"
        size="lg"
        body={
          <MaintenanceChecklistAdditionalActivityForm
            onSubmit={onSubmit}
            registeredBusId={maintenanceChecklist.registeredBusId}
            requiredField
            showFooter
          />
        }
        onClickCancel={closeModal}
        onClickClose={closeModal}
      />

      <Button
        type="button"
        color="success"
        onClick={openModal}
        disabled={disabled || !maintenanceChecklist || !maintenanceChecklist.id}
      >
        <i className="fa fa-plus mr-1" />
        Agregar actividad adicional
      </Button>
    </>
  );
};

MaintenanceChecklistAdditionalActivityButton.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  maintenanceChecklist: PropTypes.object.isRequired,

  dispatchPostMaintenanceChecklistAdditionalActivities:
    PropTypes.func.isRequired,

  dispatchGetMaintenanceChecklist: PropTypes.func.isRequired,

  disabled: PropTypes.bool,
};

MaintenanceChecklistAdditionalActivityButton.defaultProps = {
  disabled: false,
};

const mapDispatchToProps = {
  dispatchPostMaintenanceChecklistAdditionalActivities:
    postMaintenanceChecklistAdditionalActivities,

  dispatchGetMaintenanceChecklist: getMaintenanceChecklist,
};

export default connect(
  null,
  mapDispatchToProps,
)(MaintenanceChecklistAdditionalActivityButton);
